import { useToggle } from "@artists/devkit"
import { Confirm } from "@artists/uikit"
import { Button } from "@mui/material"
import { differenceInHours } from "date-fns"
import { useTranslation } from "react-i18next"
import { useTypedState } from "react-router-typesafe-routes/dom"

import { format, Root } from "../../../../utils"

interface Props {
	votingClosesAt: string
}

export const LastDayPrompt = ({ votingClosesAt }: Props) => {
	const { t } = useTranslation("vote")
	const { hideWarning } = useTypedState(Root.Vote)

	const now = new Date()
	const closingDate = new Date(votingClosesAt)
	const closesWithin24Hours =
		now < closingDate && differenceInHours(closingDate, now) <= 24

	const { title, primaryButton } = t("warnings.lastDay", {
		returnObjects: true,
	})
	const subtitle = t("warnings.lastDay.text", {
		date: format(votingClosesAt, "eee, MMM d"),
		time: format(votingClosesAt, "ha z"),
	})

	const [isOpen, _, close] = useToggle(closesWithin24Hours && !hideWarning)

	return (
		<Confirm
			open={isOpen}
			onClose={close}
			title={title}
			subtitle={subtitle}
			onConfirm={close}
			confirmText={primaryButton}
			actions={[
				<Button
					color='secondary'
					variant='contained'
					onClick={close}
					sx={{ textTransform: "none" }}
				>
					{primaryButton}
				</Button>,
			]}
		/>
	)
}
